module.exports = __webpack_public_path__ + "static_portal/img/table.31610dae.jpg";